import { render } from "./firstSection.vue?vue&type=template&id=0ef1ff11"
const script = {}

import "./firstSection.vue?vue&type=style&index=0&id=0ef1ff11&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__